export default __webpack_public_path__ + "static/media/elusivenature.8ce3c768.png";